<template>
  <div v-if="video">
    <div
      class="px-4 sm:px-6 md:px-8 mb-8 flex items-center justify-between flex-wrap sm:flex-no-wrap"
    >
      <div>
        <h1 class="text-2xl font-semibold text-gray-900">{{ video.title }}</h1>
      </div>
      <div class="flex-shrink-0">
        <div class="flex">
          <div class="w-48 rounded-md shadow-sm">
            <select
              v-model="status"
              id="status"
              class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 max-w-2xs"
            >
              <option value="0">Derush à faire</option>
              <option value="1">Derush en cours</option>
              <option value="2">Derush terminé</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="mx-auto px-4 sm:px-6 md:px-8 mt-4">
      <div class="flex flex-col">
        <div
          class="relative overflow-hidden md:pr-8"
          style="padding-top: 56.25%;"
        >
          <iframe
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
            :src="`https://player.twitch.tv/?video=v${video.twitch_id}`"
            frameborder="0>"
            scrolling="no"
            allowfullscreen="true"
          >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    components: {},
    data() {
        return {
            status: "0"
        };
    },
    computed: {
        ...mapGetters("video", ["videos", "currentPaginateVideos"]),
        video() {
            return this.currentPaginateVideos
                ? this.currentPaginateVideos.filter(video => {
                    return video.id === parseInt(this.$route.params.id);
                })[0]
                : null;
        }
    },
    methods: {
        setCurrentData() {
            if (this.video) {
                this.status = this.video.status;
            }
        }
    },
    watch: {
        status(value) {
            this.$store
                .dispatch("video/update", {
                    id: this.video.id,
                    status: value
                })
                .then(res => {
                    console.log(res);
                })
                .catch(err => {
                    console.log(err.response);
                });
        }
    },
    mounted() {
        if (!this.video) {
            console.log("todo");
        }
        this.setCurrentData();
    }
};
</script>
